export interface AggregateReportState {

  loader: boolean;
  length: number;
  resetResult: boolean;
}

export const initialAggregateReportState: AggregateReportState = {
  loader: false,
  length: 0,
  resetResult: null
}